import React from 'react'

import DisplayLabel from 'components/DisplayLabel'
import Grid from 'components/Grid'
import Paper from 'components/Paper'
import Review from 'components/Review'
import RatingCriteria from 'components/Review/components/RatingCriteria'
import Section from 'components/Section'
import { EventContext } from 'context/EventContext'
import { formatRatingAverage } from 'helpers/formatters'
import useViewport from 'hooks/useViewport'

import emptyStateBigSVG from 'assets/empty-state-big.svg'

import classes from './Reviews.module.scss'

const Reviews = ({ listing }) => {
  const { up } = useViewport()
  const snippetsPros = (listing.reviews.snippets || []).filter(snippet => snippet.type === 'pros').slice(0, 3)
  const snippetsCons = (listing.reviews.snippets || []).filter(snippet => snippet.type === 'cons').slice(0, 3)

  const showOverallRating =
    listing.reviews.positive_percentage > 0 &&
    listing.reviews.total > 0 &&
    formatRatingAverage(listing.reviews.rating_avg)

  return (
    <Paper className={classes.root}>
      <EventContext value={{ engagementComponent: 'product_reviews' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={4}>
            <div className={classes.summaryContainer}>
              <div className={classes.summaryItem}>
                {showOverallRating ? (
                  <Grid container>
                    <Grid item xs sm={6} lg={12}>
                      <DisplayLabel label="Overall rating" variant={up('sm') ? 'large' : 'small'} />
                      <Review.Display
                        href={listing.cta_urls.reviews}
                        rating={listing.reviews.rating_avg}
                        reviewsNumber={listing.reviews.total}
                        variant={up('sm') ? 'large' : 'small'}
                      />
                    </Grid>
                    <Grid className={classes.percentDisplayContainer} item xs sm={6} lg={12}>
                      <DisplayLabel label="Positive reviews" variant={up('sm') ? 'large' : 'small'} />
                      <Review.PercentDisplay
                        href={listing.cta_urls.write_review}
                        reviews={listing.reviews}
                        variant={up('sm') ? 'large' : 'small'}
                      />
                    </Grid>
                  </Grid>
                ) : (
                  <div className={classes.emptyStateContainer}>
                    <p className={classes.emptyStateTitle}>Overall rating</p>
                    <img src={emptyStateBigSVG.src} alt="empty-state-img" className={classes.emptyStateImg} />
                    <p className={classes.emptyStateText}>No reviews</p>
                  </div>
                )}
              </div>
            </div>
          </Grid>
          <Grid item xs={12} lg={8}>
            <Grid container spacing={3} className={classes.summaryRatings}>
              <Grid item xs={12} sm={6}>
                <div className={classes.subtitle}>Rating breakdown</div>
                <div className={classes.item}>
                  <RatingCriteria fields={listing.reviews.by_field} />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={classes.subtitle}>Rating distribution</div>
                <div className={classes.item}>
                  <Review.BreakdownDisplay reviewsByRating={listing.reviews.by_rating} />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid className={classes.content}>
          {listing.reviews.snippets.length > 0 && (
            <>
              <Section.Separator />
              <div>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <div className={classes.subtitle}>Pros</div>
                    <div className={classes.snippets}>
                      {snippetsPros.map(snippet => (
                        <Review.Snippet size="large" type="pros" snippet={snippet} key={snippet.text} writeReview />
                      ))}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <div className={classes.subtitle}>Cons</div>
                    <div className={classes.snippets}>
                      {snippetsCons.map(snippet => (
                        <Review.Snippet size="large" type="cons" snippet={snippet} key={snippet.text} writeReview />
                      ))}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </>
          )}

          <Grid container>
            <Grid item sm={6} xs />
            <Grid sm={6} xs={12} item className={classes.reviewsCta} />
          </Grid>
        </Grid>
      </EventContext>
    </Paper>
  )
}

export default Reviews
